<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>售后管理</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: pageUp.path }">{{pageUp.name}}</el-breadcrumb-item>
      <el-breadcrumb-item>订单作废</el-breadcrumb-item>
    </el-breadcrumb>
    
    <dev>
      
      <el-row>
        <el-col :span="6"><p class="text_c">基本信息</p></el-col>
      </el-row>
      
      <el-row>
        <el-col :span="4">
          <span class="text_l">订单编号：</span>
          <span class="text">{{orderInfo.orderNo}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">订单状态：</span>
          <span class="text">{{orderInfo.orderStatus}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">订单类型：</span>
          <span class="text">{{orderInfo.orderType}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">接单时间：</span>
          <span class="text">{{orderInfo.orderDateTime}}</span>
        </el-col>
        <el-col :span="6">
          <span class="text_l">发货日期：</span>
          <span class="text">{{orderInfo.deliveryDate}}</span>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="4">
          <span class="text_l">母单号：</span>
          <span class="text">{{orderInfo.motherorderNo}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">发货方式：</span>
          <span class="text">{{orderInfo.logisticsMode}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">责任界定：</span>
          <span class="text">{{orderInfo.duty}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">接单客服：</span>
          <span class="text">{{orderInfo.orderReceivPerson}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">开单员：</span>
          <span class="text">{{orderInfo.billingPerson}}</span>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="4">
          <span class="text_l">库区：</span>
          <span class="text">{{orderInfo.warehouseRegion}}</span>
        </el-col>
        
        <el-col :span="4">
          <span class="text_l">库存：</span>
          <span class="text">{{orderInfo.inventory}}</span>
        </el-col>
        
        <el-col :span="4">
          <span class="text_l">颜色：</span>
          <span class="text">{{orderInfo.colour}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">规格型号：</span>
          <span class="text">{{orderInfo.speModel}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">外采产品：</span>
          <span class="text">{{ orderInfo.outsideProduct ? '是' : '否' }}</span>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="4"><p class="text_c">收发货信息</p></el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <span class="text_l">订货店铺：</span>
          <span class="text">{{orderInfo.shop}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">发货员：</span>
          <span class="text">{{orderInfo.shippingClerk}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">店铺电话：</span>
          <span class="text">{{orderInfo.shopPhone}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">发货地址：</span>
          <span class="text">{{orderInfo.shipAddr}}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <span class="text_l">客户ID：</span>
          <span class="text">{{orderInfo.customerId}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">客户姓名：</span>
          <span class="text">{{orderInfo.customerName}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">客户电话：</span>
          <span class="text">{{orderInfo.customerPhone}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">收货地址：</span>
          <span class="text">{{orderInfo.customerAddr}}</span>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="4"><p class="text_c">产品信息</p></el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <span class="text_l">产品名称：</span>
          <span class="text">{{orderInfo.productName}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">套数：</span>
          <span class="text">{{orderInfo.quantity}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">包装：</span>
          <span class="text">{{orderInfo.packingRequirements}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">柜体面积：</span>
          <span class="text">{{orderInfo.cabinetArea}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">单价：</span>
          <span class="text">{{orderInfo.unitPrice}}</span>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="4">
          <span class="text_l">柜体费用：</span>
          <span class="text">{{orderInfo.cabinetCost}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">五金费用：</span>
          <span class="text">{{orderInfo.metalsCost}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">外采费用：</span>
          <span class="text">{{orderInfo.outsideProductCost}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">安装费用：</span>
          <span class="text">{{orderInfo.installCost}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">物流费用：</span>
          <span class="text">{{orderInfo.packCost}}</span>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="4">
          <span class="text_l">附加费：</span>
          <span class="text">{{orderInfo.subjoinCost}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">订单金额：</span>
          <span class="text">{{orderInfo.totalMoney}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">付款方式：</span>
          <span class="text">{{orderInfo.paymentMethod}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">预付：</span>
          <span class="text">{{orderInfo.prepay}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">月结：</span>
          <span class="text">{{orderInfo.monthBond}}</span>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="4">
          <span class="text_l">打包数量：</span>
          <span class="text">{{orderInfo.packingNum}}</span>
        </el-col>
        <el-col :span="4">
          <span class="text_l">打框数量：</span>
          <span class="text">{{orderInfo.woodenBoxNum}}</span>
        </el-col>
      </el-row>
      
      <el-row style="margin-top: 1%;">
        <el-col :span="20">
          <span class="text_l">备注：</span>
          <span class="text">{{orderInfo.remarks}}</span>
        </el-col>
      </el-row>
      
      <el-row style="margin-top: 1%;">
        <el-col :span="1">
          <span class="text_l">作废描述：</span>
        </el-col>
        <el-col :span="12">
          <el-input v-model="cancelInfo.cancelExp" style="width: 80%;"></el-input>
        </el-col>
      </el-row>
      
      <el-row style="margin-top: 1%;">
        <el-col>
          <el-button type="primary" @click="cancelOrder" :disabled="cancel">作废订单</el-button>
        </el-col>
      </el-row>
    </dev>
    
  </div>
</template>

<script>
export default {
    data() {
      return {
        orderInfo: {
        },
        
        cancelInfo:{
          id: "",
          cancelCond: 1,
          cancelExp: "",
          cancelTime: "",
          cancelPerson: "",
        },
        //是否作废ok
        cancel: false,
        pageUp: {
          path: '/order/list',
          name: '订单列表'
        }
        
      };
    },
    methods: {
        cancelOrder() {
          if(this.cancelInfo.cancelExp.trim() == "")
          {
            alert("请填写作废描述！")
            return;
          }
          
          this.$confirm('确定作废该订单吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then( async () => {
            
            this.cancelInfo.cancelTime = this.getNowFormatDateTime();
            this.cancelInfo.cancelPerson = window.localStorage.getItem("userCompellation");
            
            const {data:res} = await this.$http.put('/api/s-order/modif', this.cancelInfo)
            if(res.code == 1)
            { 
              this.$message({
                type: 'success',
                message: '作废成功!'
              });
              
              //报价完成后的修改再添加跟踪
              if(this.orderInfo.orderStatus !== "预备订单" && this.orderInfo.orderStatus !== "受理订单")
              {
                //添加一条跟踪记录
                let tailInfo = {
                  orderNo: this.orderInfo.orderNo,
                  status: "订单被作废，作废原因："+this.cancelInfo.cancelExp,
                  tailTime: this.getNowFormatDateTime(),
                  operator: window.localStorage.getItem("userCompellation"),
                }
                const { data } = await this.$http.post("/api/s-order-tail/create", tailInfo)
              }
              //保存一份到履历订单
              /* this.orderInfo.id = null
              this.orderInfo.modifyReason = "订单被作废，作废原因："+this.cancelInfo.cancelExp
              this.orderInfo.modifyTime = this.getNowFormatDateTime();
              this.orderInfo.modifyPerson = window.localStorage.getItem('userCompellation')
              this.$http.post('/api/s-order-modify-record/create', this.orderInfo) */
            
              //作废完成就不能再作废了，使作废按钮失效
              this.cancel = true;
            }
            else
            {
              this.$message.error('系统错误！');
            }
            
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消作废'
            });          
          });
          
        },
        getParams(){
          this.pageUp.path = this.$route.query.pageUpPath;
          this.pageUp.name = this.$route.query.pageUpName;
          this.cancelInfo.id = this.$route.query.orderId;
        },
        async getOrderInfo()
        {
          const { data } = await this.$http.get("/api/s-order/getByIdOrderTable/"+this.cancelInfo.id);
          if (data.code == 1) {
            this.orderInfo = data.data
          }
        }
    },
    created(){
      //解除其他页面的按键监听
      document.onkeydown = null
      
      this.getParams();
      this.getOrderInfo();
    }
  };
</script>

<style>

.text_c{
  font-size: 16px;
  margin-top: 20px;
  margin-bottom: 7px;
  font-weight: bold;
}
.text_l{
  font-size: 13px;
  font-weight: bold;
}
.text{
  font-size: 13px;
}

</style>
